import { render, staticRenderFns } from "./HeadersActionDialog.vue?vue&type=template&id=67b473b9"
import script from "./HeadersActionDialog.vue?vue&type=script&lang=js"
export * from "./HeadersActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports